import logo from './logo.svg';
import './App.css';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import Comment from './component/comment/Comment'

function App(props) {
  return (
    <div className="App">
       <NotificationContainer/>
      <Comment props={props} />
    </div>
  );
}

export default App;
